import { BaseIntegration } from '../base-integration/base-integration';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService } from '../../../../../services/notifications.service';
import { ChannelService } from '../../../../../services/channel.service';
import { IntegrationService } from '../../../../../services/integration.service';
import { BaseService } from '../../../../../services/base.service';
import { WebSocketService } from '../../../../../services/gateway.service';
import {
  CHANNEL_STATUS,
  CHANNEL_STATUS_OBJECT,
  CHANNEL_TYPE,
  DEFAULT_ERROR,
  ERROR_MESSAGES,
  activeTranslations,
} from '../../../../../enum/constants';
import { FormControl, Validators } from '@angular/forms';
import { trimValidator } from '../../../../../helpers';
import { takeUntil } from 'rxjs';
import { ISocketIntegrationEvent, SocketIntegrationAction } from '../integration-instagram/integration.interface';

@Component({
  selector: 'app-integration-prom',
  templateUrl: './integration-prom.component.html',
  styleUrls: ['./integration-prom.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationPromComponent extends BaseIntegration implements OnInit, OnDestroy {
  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  constructor(
    protected override readonly notificationService: NotificationService,
    protected override readonly channelService: ChannelService,
    protected override readonly integrationService: IntegrationService,
    protected readonly baseService: BaseService,
    protected readonly webSocketService: WebSocketService,
  ) {
    super(integrationService, notificationService, channelService);
  }

  protected tokenControl: FormControl = new FormControl('', [Validators.required, trimValidator]);

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.channel_id = this.payload.channel_id;
    this.initSockets();
    this.getChannelById();
  }

  private initSockets() {
    this.webSocketService
      .promChannelAction()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.handleChannelAction(data);
        },
      });
  }

  protected connectAccount() {
    this.channelService.checkConnect({ type: CHANNEL_TYPE.PROM }).subscribe({
      next: (data: any) => {
        if (!data) return;
        if (this.tokenControl.invalid) {
          this.tokenControl.markAsTouched();
          return;
        }
        this.createProm();
      },
    });
  }

  private createProm() {
    this.isLoader = true;
    this.integrationService
      .createProm(this.channel_id, this.tokenControl.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        error: (res: any) => {
          (res.error?.errors || []).forEach((err: any) => {
            this.notificationService.showError('', ERROR_MESSAGES[err.code] || DEFAULT_ERROR);
            this.isLoader = false;
          });
        },
      });
  }

  private handleChannelAction(data: ISocketIntegrationEvent) {
    if (this.channel_id !== data.channel_id) return;

    switch (data.action) {
      case SocketIntegrationAction.SUCCESS: {
        this.getChannelById();
        break;
      }

      case SocketIntegrationAction.PROCESSED: {
        this.isLoader = true;
        break;
      }

      case SocketIntegrationAction.FAILED: {
        this.isLoader = false;
        if (data.error) {
          this.notificationService.showError(
            activeTranslations.notifications_texts.error.error,
            ERROR_MESSAGES[data.error] || DEFAULT_ERROR,
          );
        }
        break;
      }
    }
  }

  protected readonly CHANNEL_STATUS = CHANNEL_STATUS;
  protected readonly CHANNEL_STATUS_OBJECT = CHANNEL_STATUS_OBJECT;
}
